import type { Node as PMNode } from '@tiptap/pm/model';

const isEmptyParagraph = (node: PMNode): boolean => node.type.name === 'paragraph' && node.content.size === 0;

export default isEmptyParagraph;
